import { useEffect, useRef, useState } from 'react';

export default function useReveal(threshold = 0.08, rootMargin = '280px 0px') {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    const el = ref.current;

    const reveal = () => setVisible(true);

    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          reveal();
          obs.disconnect();
        }
      },
      { threshold, rootMargin }
    );
    obs.observe(el);

    // After Back restores scroll (useLayoutEffect), reveal if already on-screen
    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        reveal();
        obs.disconnect();
      }
    };
    const t1 = requestAnimationFrame(check);
    const t2 = setTimeout(check, 50);
    const t3 = setTimeout(check, 250);

    return () => {
      cancelAnimationFrame(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      obs.disconnect();
    };
  }, [threshold, rootMargin]);

  return [ref, visible];
}
